export default __webpack_public_path__ + "static/media/PRATIQUE.883944dc.png";